<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <app-form-control label="Adres e-mail">
    <input
      [formControl]="form.controls.email"
      appPrimengInputText
      pInputText
      type="text" />
  </app-form-control>

  <app-form-control inputId="6664cd4d-07d8-4ef5-9428-de79e6b6d9ff">
    <app-checkbox-with-label inputId="6664cd4d-07d8-4ef5-9428-de79e6b6d9ff">
      <p-checkbox
        [binary]="true"
        [formControl]="form.controls.regulations" />
      <app-regulations-checkbox-label label />
    </app-checkbox-with-label>
  </app-form-control>

  <app-privacy-policy-clause />

  <div class="flex justify-center">
    <app-form-control>
      <app-re-captcha [formControl]="form.controls.recaptcha" />
    </app-form-control>
  </div>

  <div>
    <p-button
      [disabled]="form.invalid"
      [fluid]="true"
      appPrimengButton
      label="Zapisz mnie!"
      type="submit" />
  </div>
</form>
